import React from "react";

const sizes = {
  headingxs: "text-[12px] font-extrabold",
  headings: "text-[13px] font-black",
  headingmd: "text-[14px] font-bold",
  headinglg: "text-[16px] font-black lg:text-[13px]",
  headingxl: "text-[18px] font-extrabold lg:text-[15px]",
  heading2xl: "text-[22px] font-extrabold lg:text-[18px]",
  heading3xl: "text-[24px] font-bold lg:text-[20px] md:text-[22px]",
};

const Heading = ({ children, className = "", size = "headinglg", as, ...restProps }) => {
  const Component = as || "h6";

  return (
    <Component className={`text-black-900_01 font-atma ${className} ${sizes[size]}`} {...restProps}>
      {children}
    </Component>
  );
};

export { Heading };
